<div class="input-group input-group--city">
  <label>{{ 'public-profile.identity.city.label' | transloco }}</label>

  <input type="text"
         [formControl]="inputCtrl"
         name="city"
         id="city"
         placeholder="{{ 'public-profile.identity.city.placeholder' | transloco }}"
         (focusin)="handleFocusIn()"
         (blur)="handleBlur()"
         (keydown.enter)="handleEnter()"
         autocomplete="off"
         aria-autocomplete="list"
         aria-haspopup="listbox"
         [attr.aria-expanded]="citiesSuggestionsShown"/>

  @if (citiesSuggestionsShown || loadingCities) {
    @if (loadingCities) {
      <div class="autocomplete-suggestions">
        <div class="skeleton-loading"></div>
        <div class="skeleton-loading"></div>
        <div class="skeleton-loading"></div>
        <div class="skeleton-loading"></div>
        <div class="skeleton-loading"></div>
      </div>
    } @else {
      <ul class="autocomplete-suggestions" role="listbox">
        @if (filteredCities.length === 0) {
          <p>{{ 'public-profile.identity.city.empty' | transloco }}</p>
        }
        @if (filteredCities.length > 0) {
          @for (city of filteredCities; track city) {
            <li role="option" (mousedown)="selectCity(city)">{{ city }}</li>
          }
        }
      </ul>
    }
  }
</div>
